import * as React from "react"
import { List } from "immutable"
import { Link } from "./library/link"
import Slider from "react-slick"

export type QuickLinksProps = {
  className?: string
  sliderClassName?: string
  title: string
  links: List<QuickLink>
  slider?: boolean
  handleScroll: (slug: string) => void
  pushAnalyticsEvent: (action: string) => void
}

export type QuickLink = {
  title: string
  url: string
}

export const setCustomArrowsFocus = () => {
  const arrows = document.querySelectorAll(".slick-arrow")
  arrows.forEach(item => {
    item.className.includes("slick-disabled")
      ? item.setAttribute("disabled", "true")
      : item.removeAttribute("disabled")
  })
}

export const QuickLinks = (p: QuickLinksProps): JSX.Element => {
  const links = p.links.map((c, i) => (
    <li key={`group-scroll-${i}`} className="quicklink">
      <div className="quicklink__inner">
        <Link
          url={c.url}
          title={c.title}
          className="quicklink__link"
          handle={() => {
            p.pushAnalyticsEvent(c.title)
            if (c.url.startsWith("#")) {
              p.handleScroll(c.url.substring(1))
            }
          }}
        >
          {c.title}
        </Link>
      </div>
    </li>
  ))

  return (
    <nav className={`quicklinks ${p.className ? p.className : ""}`} aria-label="Snelkoppelingen">
      {p.title ? <p className="quicklinks__title">{p.title}</p> : <></>}
      {!p.slider ? (
        <ul className="quicklinks__list">{links}</ul>
      ) : (
        <Slider
          {...{
            accessibility: true,
            dots: false,
            arrows: true,
            infinite: false,
            variableWidth: true,
            className: p.sliderClassName ? p.sliderClassName : "menuslider",
            speed: 500,
            swipeToSlide: true,
            slidesToScroll: 3,
            centerMode: false,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToScroll: 1,
                },
              },
            ],
            onReInit: () => {
              const slides = document.querySelectorAll('.slick-slide');
                slides.forEach((slide) => {
                slide.setAttribute('aria-hidden', 'false')
              })
              setCustomArrowsFocus()
            },
            slickPrev: () => {
              setCustomArrowsFocus()
            },
            slickNext: () => {
              setCustomArrowsFocus()
            },
          }}
        >
          {links}
        </Slider>
      )}
    </nav>
  )
}
